// Presence-specific socket helpers: identify + latency ping/pong.

export function createPresenceSocketClient(socket) {
  let latestLatencyMs = null;
  let latencyTimer;

  const emitIdentify = (payload) => {
    if (!socket) return;
    socket.emit('presence:identify', payload);
  };

  const startLatencyPing = (
    intervalMs = 5_000,
    { onLatency } = {},
  ) => {
    if (!socket) return () => {};

    const handlePong = (sentAt) => {
      if (typeof sentAt !== 'number') return;
      latestLatencyMs = Date.now() - sentAt;
      if (typeof onLatency === 'function') {
        onLatency(latestLatencyMs);
      }
    };

    socket.on('presence:latency:pong', handlePong);

    const ping = () => {
      socket.emit('presence:latency:ping', Date.now());
    };

    ping();
    latencyTimer = setInterval(ping, intervalMs);

    return () => {
      clearInterval(latencyTimer);
      socket.off('presence:latency:pong', handlePong);
    };
  };

  return {
    emitIdentify,
    startLatencyPing,
    getLatency: () => latestLatencyMs,
  };
}

export default createPresenceSocketClient;
